@if (!loaded) {
  <div class="pt-64 text-center">
    <span
      class="m-auto text-6xl text-grey-medium icon-spinner-outline animate-spin pi-original duration-3000"
    ></span>
  </div>
}

@if (markup) {
  <div class="markdown-body" [innerHtml]="markup | safe: 'html'"></div>
}
